import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, Suspense } from 'react';
import HomePage from './Views/HomePage';
import LoginPage from './Views/LoginPage';
import Dashboard from './Views/Dashboard';
import VerifyEmail from './Views/VerifyEmail';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import SecurityProvider from './components/SecurityProvider';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

// Loading component with minimal UI
const LoadingScreen = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    height: '100vh',
    backgroundColor: '#f5f5f5'
  }}>
    <div>Loading...</div>
  </div>
);

function AppRoutes() {
  const { loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />

      {/* Protected routes */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/verify-email" element={
        <ProtectedRoute>
          <VerifyEmail />
        </ProtectedRoute>
      } />

      {/* Redirect all unauthorized/unknown routes to home */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  // Force HTTPS in production
  useEffect(() => {
    if (window.location.protocol === 'http:' && process.env.NODE_ENV === 'production') {
      window.location.href = window.location.href.replace('http:', 'https:');
    }
  }, []);

  return (
    <ErrorBoundary>
      <SecurityProvider>
        <AuthProvider>
          <Suspense fallback={<LoadingScreen />}>
            <Router>
              <AppRoutes />
            </Router>
          </Suspense>
        </AuthProvider>
      </SecurityProvider>
    </ErrorBoundary>
  );
}

export default App;
